export default __webpack_public_path__ + "static/media/volkihar-slide-1-large.908dffe7.jpg";